import * as AT from '../constants/actionTypes'

/**
 * Panel changes reducer
 * @param {*} state 
 * @param {*} action 
 */
function panelChange(state = { panelChanges: [], allPanelChanges: [] }, action) {
	switch (action.type) {
		case AT.PROFILE_LOGOUT:
		case AT.RESET_ALL:
			return Object.assign({}, state, {
				panelChanges: []
			})
		case AT.PANELCHANGES_ALL_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				panelChanges: [],
				allPanelChanges: [],
				error: undefined
			})
		case AT.PANELCHANGES_ALL_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.PANELCHANGES_ALL_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				allPanelChanges: action.payload.allPanelChanges,
				error: undefined
			})				
		case AT.PANELCHANGES_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				allPanelChanges: [],
				panelChanges: [],
				error: undefined
			})
    	case AT.PANELCHANGES_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
    	case AT.PANELCHANGES_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				panelChanges: action.payload.panelChanges,
				error: undefined
			})
		case AT.PANELCHANGE_REMOVING_STARTED:
			return Object.assign({}, state, {
				isRemoving: true,
				error: undefined
			})
		case AT.PANELCHANGE_REMOVING_FAILED:
			return Object.assign({}, state, {
				isRemoving: false,
				error: action.payload.error
			})
		case AT.PANELCHANGE_REMOVING_FINISHED:
			return Object.assign({}, state, {
				isRemoving: false,
				panelChanges: state.panelChanges.filter( pc => pc.id !== action.payload.id ),
				error: undefined
			})
		case AT.PANELCHANGE_ADD_TARGET_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.PANELCHANGE_ADD_TARGET_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.PANELCHANGE_ADD_TARGET_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				error: undefined
			})
		case AT.PANELCHANGE_MODIFY_TARGET_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.PANELCHANGE_MODIFY_TARGET_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.PANELCHANGE_MODIFY_TARGET_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				error: undefined
			})
		case AT.PANELCHANGE_REMOVE_TARGET_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.PANELCHANGE_REMOVE_TARGET_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.PANELCHANGE_REMOVE_TARGET_FINISHED:
			return Object.assign({}, state, {
				isSaving: false,
				error: undefined
			})
		case AT.PANELCHANGE_SETSTATUS_STARTED:
			return Object.assign({}, state, {
				isSaving: true,
				error: undefined
			})
		case AT.PANELCHANGE_SETSTATUS_FAILED:
			return Object.assign({}, state, {
				isSaving: false,
				error: action.payload.error
			})
		case AT.PANELCHANGE_SETSTATUS_FINISHED:
			let changedPC = state.panelChanges.filter( p => p.id === action.payload.id)[0];
			changedPC.isProcessed = action.payload.status;
			return Object.assign({}, state, {
				isSaving: false,
				panelChanges: [ ...state.panelChanges.filter( p => p.id !== action.payload.id), changedPC ],
				error: undefined
			})			
		case AT.PANELCHANGE_UI_CLEAR:
			return Object.assign({}, state, {
				error: undefined
			})
		default: return state;
	}
}

export default panelChange;